import { ChargingStationInformation } from '@/models/charging-station-declaration'

export interface ChargingStationInformationState {
stations: ChargingStationInformation[] | null
}

export const InitialState: ChargingStationInformationState = {
  stations: null
}
